/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TreatmentPlanDto
 */
export interface TreatmentPlanDto {
    /**
     * Treatment plan ID
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    id: string;
    /**
     * Patient ID
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    patientId: string;
    /**
     * Provider ID
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    providerId?: string;
    /**
     * Protocol file path (treatment plan text)
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    txtPath?: string;
    /**
     * Canvas file path
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    canvasPath?: string;
    /**
     * Podcast file path (audio treatment plan)
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    audioPath?: string;
    /**
     * Text generation token usage
     * @type {number}
     * @memberof TreatmentPlanDto
     */
    txtTokenUsage?: number;
    /**
     * Canvas generation token usage
     * @type {number}
     * @memberof TreatmentPlanDto
     */
    canvasTokenUsage?: number;
    /**
     * PDF report path
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    pdfReportPath?: string;
    /**
     * PDF report URL
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    pdfReportUrl?: string;
    /**
     * PDF report token usage
     * @type {number}
     * @memberof TreatmentPlanDto
     */
    pdfReportTokenUsage?: number;
    /**
     * PDF processing time in milliseconds
     * @type {number}
     * @memberof TreatmentPlanDto
     */
    pdfProcessingTime?: number;
    /**
     * Protocol txt file path
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    protocolTxtPath?: string;
    /**
     * Protocol txt file URL
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    protocolTxtUrl?: string;
    /**
     * Feedback for the treatment plan
     * @type {object}
     * @memberof TreatmentPlanDto
     */
    feedback?: object;
    /**
     * Created at timestamp
     * @type {Date}
     * @memberof TreatmentPlanDto
     */
    createdAt: Date;
    /**
     * Updated at timestamp
     * @type {Date}
     * @memberof TreatmentPlanDto
     */
    updatedAt: Date;
    /**
     * Download URL for protocol file (TXT/DOCX) - signed URL for direct download (temporary, expires in 1 hour)
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    txtUrl?: string;
    /**
     * Download URL for canvas file - signed URL for direct download (temporary, expires in 1 hour)
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    canvasUrl?: string;
    /**
     * Download URL for audio/podcast file (MP3) - signed URL for direct download/stream (temporary, expires in 1 hour)
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    audioUrl?: string;
    /**
     * Download URL for PDF report - signed URL for GCS files or direct URL for external links (gamma.app, etc.)
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    pdfUrl?: string;
    /**
     * Download URL for instruction file (DOCX/PDF) - signed URL for direct download (temporary, expires in 1 hour)
     * @type {string}
     * @memberof TreatmentPlanDto
     */
    instructionUrl?: string;
    /**
     * Chatbot conversation information
     * @type {object}
     * @memberof TreatmentPlanDto
     */
    conversation?: object;
    /**
     * Patient information
     * @type {object}
     * @memberof TreatmentPlanDto
     */
    patient?: object;
    /**
     * Provider information
     * @type {object}
     * @memberof TreatmentPlanDto
     */
    provider?: object;
}

/**
 * Check if a given object implements the TreatmentPlanDto interface.
 */
export function instanceOfTreatmentPlanDto(value: object): value is TreatmentPlanDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function TreatmentPlanDtoFromJSON(json: any): TreatmentPlanDto {
    return TreatmentPlanDtoFromJSONTyped(json, false);
}

export function TreatmentPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TreatmentPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'providerId': json['providerId'] == null ? undefined : json['providerId'],
        'txtPath': json['txtPath'] == null ? undefined : json['txtPath'],
        'canvasPath': json['canvasPath'] == null ? undefined : json['canvasPath'],
        'audioPath': json['audioPath'] == null ? undefined : json['audioPath'],
        'txtTokenUsage': json['txtTokenUsage'] == null ? undefined : json['txtTokenUsage'],
        'canvasTokenUsage': json['canvasTokenUsage'] == null ? undefined : json['canvasTokenUsage'],
        'pdfReportPath': json['pdfReportPath'] == null ? undefined : json['pdfReportPath'],
        'pdfReportUrl': json['pdfReportUrl'] == null ? undefined : json['pdfReportUrl'],
        'pdfReportTokenUsage': json['pdfReportTokenUsage'] == null ? undefined : json['pdfReportTokenUsage'],
        'pdfProcessingTime': json['pdfProcessingTime'] == null ? undefined : json['pdfProcessingTime'],
        'protocolTxtPath': json['protocolTxtPath'] == null ? undefined : json['protocolTxtPath'],
        'protocolTxtUrl': json['protocolTxtUrl'] == null ? undefined : json['protocolTxtUrl'],
        'feedback': json['feedback'] == null ? undefined : json['feedback'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'txtUrl': json['txtUrl'] == null ? undefined : json['txtUrl'],
        'canvasUrl': json['canvasUrl'] == null ? undefined : json['canvasUrl'],
        'audioUrl': json['audioUrl'] == null ? undefined : json['audioUrl'],
        'pdfUrl': json['pdfUrl'] == null ? undefined : json['pdfUrl'],
        'instructionUrl': json['instructionUrl'] == null ? undefined : json['instructionUrl'],
        'conversation': json['conversation'] == null ? undefined : json['conversation'],
        'patient': json['patient'] == null ? undefined : json['patient'],
        'provider': json['provider'] == null ? undefined : json['provider'],
    };
}

export function TreatmentPlanDtoToJSON(json: any): TreatmentPlanDto {
    return TreatmentPlanDtoToJSONTyped(json, false);
}

export function TreatmentPlanDtoToJSONTyped(value?: TreatmentPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'providerId': value['providerId'],
        'txtPath': value['txtPath'],
        'canvasPath': value['canvasPath'],
        'audioPath': value['audioPath'],
        'txtTokenUsage': value['txtTokenUsage'],
        'canvasTokenUsage': value['canvasTokenUsage'],
        'pdfReportPath': value['pdfReportPath'],
        'pdfReportUrl': value['pdfReportUrl'],
        'pdfReportTokenUsage': value['pdfReportTokenUsage'],
        'pdfProcessingTime': value['pdfProcessingTime'],
        'protocolTxtPath': value['protocolTxtPath'],
        'protocolTxtUrl': value['protocolTxtUrl'],
        'feedback': value['feedback'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'txtUrl': value['txtUrl'],
        'canvasUrl': value['canvasUrl'],
        'audioUrl': value['audioUrl'],
        'pdfUrl': value['pdfUrl'],
        'instructionUrl': value['instructionUrl'],
        'conversation': value['conversation'],
        'patient': value['patient'],
        'provider': value['provider'],
    };
}

